import { BarChart3, Brain, Crown, Sparkles, Zap } from "lucide-react";

export const AUTH_TOKEN_NAME = "authToken"
export const GOOGLE_AUTOCOMPLE_API_BASE_URL = "https://places.googleapis.com/v1/places:autocomplete"

export const MAX_COMPETITORS = 5;
export const MAX_HOTEL_NAME_CHARACTERS = 50;
export const ACTIVE_COMPSET_KEY_NAME = "active_compset"
export const PROWEN_AUTH_NAME = "prowen_auth"
export const PROWEN_AUTH_USER = "prowen_user"

export const REGISTER_USER_EMAIL = "user_email"

export const PLAN_ICON_MAPPER = {
    free: Sparkles,
    tier1: Zap,
    tier2: Crown,
    "basiclite": BarChart3,
    "insightlite": Brain
};

export const PLAN_NAME_MAPPER = {
    trial: "Free",
    basic: "Tier 1",
    advance: "Tier 2",
    regular: "Basic lite",
    regularWithAI: "Insight lite"
};

export const RAZORPAY_SDK_URL = "https://checkout.razorpay.com/v1/checkout.js"

export const SCHEDULE_STATUS_MAP = {
    0: { label: "Pending", color: "orange" },
    200: { label: "Success", color: "green" },
    400: { label: "Failed", color: "red" },
};

export const COMPSET_PERMISSION_MAPPER = {
    edit: {
        showCancelButton: true,
        canEditCompsetName: false,  // pre-filled & locked
    },
    create: {
        showCancelButton: false,
        canEditCompsetName: true,
    },
    update: {
        showCancelButton: true,
        canEditCompsetName: true,
    }
}


export const AUTH_STATUSES = {
    "registered": "REGISTERED",
    "verified": "VERIFIED",
    "payment_done": "PAYMENT_DONE",
    "active": "ACTIVE"
}

export const PLAN_IDS = {
    PLAN_99: '99161',
    PLAN_199: '19916',
    TIER_1: '21193',
    TIER_2: '14221',
};

export const MAX_COMPSET_NAME_LENGTH = 15;
export const COLORS = [
    '#6366f1',
    '#10b981',
    // '#3b82f6',
    '#f59e0b',
    '#ef4444',
    '#8b5cf6',
    '#ec4899',
    '#14b8a6',
    '#f97316',
    '#84cc16',
    '#06b6d4',
    '#a855f7',
    '#e11d48',
    '#22c55e',
    '#0ea5e9',
    '#d946ef',
    // additional 20 colors
    '#4f46e5', // indigo
    '#059669', // emerald
    '#2563eb', // blue
    '#d97706', // amber
    '#dc2626', // red
    '#7c3aed', // violet
    '#db2777', // pink
    '#0d9488', // teal
    '#ea580c', // orange
    '#65a30d', // lime
    '#0891b2', // cyan
    '#9333ea', // purple
    '#be123c', // rose
    '#16a34a', // green
    '#0284c7', // sky
    '#c026d3', // fuchsia
    '#f43f5e', // bright rose
    '#38bdf8', // light blue
    '#34d399', // light emerald
    '#facc15'  // yellow
];


export const ERROR_CODES = {
    "COMPSET_COMPETITOR_NOT_FOUND": "COMPETITOR_NOT_FOUND"
}